import React, { useEffect, useState } from 'react';
import Navbar from './Navbar/Navbar.component';
import Sidebar from './Sidebar/Sidebar.component';
import GridMenu from './GridMenu/GridMenu.component';
import MainDiv from './MainDiv/MainDiv.component';
import { viewType } from './Layout.types';
import { useLayoutContext } from '../../Context/Layout.context';
import { Paths } from '../../utils/routerUrls';
import useSessionUser from '../../hooks/useSessionUser';
import { useDispatch } from 'react-redux';
import { SkipLink } from '../SkipLink/SkipLink.component';

interface LayoutProps {
  viewType?: viewType;
}

export const NAVBAR_ISMINIMIZED_KEY = 'Navbar_isMinimized';

const Layout: React.FC<LayoutProps> = (props) => {
  const [isMinimized, setIsMinimized] = useState<boolean>(!!sessionStorage.getItem(NAVBAR_ISMINIMIZED_KEY));
  const [isSkipLink, setIsSkipLink] = useState<boolean>(false);
  const { setIsSidebarMinimized, stableMenuAnchor } = useLayoutContext();
  const dispatch = useDispatch();
  const user = useSessionUser();
  const sessionInfo = user?.userAssessmentSessionInfo;
  const examinerContext = sessionStorage.getItem('context') === 'examiner';

  useEffect(() => {
    sessionStorage.setItem(NAVBAR_ISMINIMIZED_KEY, isMinimized ? 'true' : '');
    setIsSidebarMinimized(isMinimized);
    //dispatch(mailboxActions.toggleIsMenuMinimized(isMinimized)); // 22524
  }, [isMinimized]);

  if (window.location.hash) {
    history.replaceState('', document.title, window.location.href.split('#')[0]);
  }
  return (
    <div>
      {/* div for stabilize menu items attached to menu filters */}
      <div ref={stableMenuAnchor} style={{ position: 'absolute' }}></div>
      <SkipLink isSkipLink={isSkipLink} setIsSkipLink={setIsSkipLink} />
      <Navbar
        viewType={props.viewType}
        changeSidebarView={() => setIsMinimized(!isMinimized)}
        getHomeUrl={() => {
          return sessionInfo?.function != undefined ||
            sessionInfo?.account_type === 'examiner' ||
            sessionInfo?.role === 'examiner'
            ? Paths.dashboard
            : Paths.adminDashboard;
        }}
        isSkipLink={isSkipLink}
      />
      <MainDiv>
        {props.viewType !== undefined && !['fullwidthForExaminer', 'fullwidthWithMenu'].includes(props.viewType) && (
          <Sidebar viewType={props.viewType} isMinimized={isMinimized} setIsMinimized={setIsMinimized} />
        )}
        <div
          id="main-content"
          style={{
            padding: '0px',
            margin: '0px',
            width: '100%',
            outline: 'none',
          }}
        >
          <GridMenu>{props.children}</GridMenu>
        </div>
      </MainDiv>
    </div>
  );
};

export default Layout;
